import ProductTour from './ProductTour';
import FeaturesSection from './FeaturesSection';

/**
 * Single painted surface for ProductTour + Signal Foundation.
 * Background and mist live on this wrapper so there is no compositing
 * edge between the two child sections.
 */
export default function SignalFoundationBridge() {
  return (
    <div className="signal-foundation-bridge signal-foundation">
      <div aria-hidden="true" className="signal-foundation-bridge__wash" />
      <div aria-hidden="true" className="signal-foundation-bridge__smoke" />

      <div className="relative z-[2]">
        <ProductTour embedded />
        <FeaturesSection embedded />
      </div>
    </div>
  );
}
